app.controller('RegisterCtrl', ['$scope', '$routeParams', '$http', '$window', '$q', 'appFactory', '$uibModal',
function ($scope, $routeParams, $http, $window, $q, appFactory, $uibModal) {

    $scope.user = {};
    $scope.ListSales = [];
    $scope.ListCabang = [];

    $scope.user.PhoneCode = '+62';
    $scope.user.QuestionRDN = '1';

    $scope.disablesales = false;
    $scope.SalesSelected = '';

    $scope.disablebranch = false;
    $scope.BranchSelected = '';

    $scope.AccountTypeList = [];

    $scope.AccountTypeList = [
        { id: "1", name: "Regular Account" },
        { id: "2", name: "Sub Account" },
        { id: "3", name: "Reksa Dana" },
        { id: "4", name: "Bond Account" },
        { id: "5", name: "Lainnya" }
    ];

    $scope.page = 'step1';

    $scope.showPassword = false;
    $scope.inputType = 'password';
    $scope.toggleShowPassword = function () {
        $scope.showPassword = !$scope.showPassword;
        if ($scope.inputType == 'password')
            $scope.inputType = 'text';
        else
            $scope.inputType = 'password';
    }

    $scope.showPasswordConfirmation = false;
    $scope.inputTypeConfirmation = 'password';
    $scope.toggleShowPasswordConfirmation = function () {
        $scope.showPasswordConfirmation = !$scope.showPasswordConfirmation;
        if ($scope.inputTypeConfirmation == 'password')
            $scope.inputTypeConfirmation = 'text';
        else
            $scope.inputTypeConfirmation = 'password';
    }

    $scope.checkPassword = function () {
        if ($scope.ConfirmPassword != $scope.user.Password) {
            $scope.formRegister.txtConfirmPassword.$invalid = true;
            $scope.infolengthpass = false;
        }
    };

    var allPromise = $q.all([
        appFactory.getData(`service/client.svc/GetCountryPhone`).then(function (data) {

            if (data.status == 200)
                $scope.ListCountryPhone = data.data.d;
        }),
         appFactory.getData(`service/client.svc/GetCIFCabang`).then(function (data) {

             if (data.status == 200)
                 $scope.ListCabang = data.data.d;
         }),

    ]);

    allPromise.then(function () {

        //if ($scope.CIFInvestor.AccountType) {

        //    $scope.CIFInvestor.AccountType = [];
        //    let temp = $scope.CIFInvestor.AccountType.split(',');

        //    for (var i = 0; i < temp.length; i++) {

        //        $scope.CIFInvestor.AccountType.push(Number(temp[i]));
        //    }
        //}

        //if ($scope.user.AccountType) {

        //    $scope.user.AccountType = [];
        //    let temp = $scope.user.AccountType.split(',');

        //    for (var i = 0; i < temp.length; i++) {

        //        $scope.user.AccountType.push(Number(temp[i]));
        //    }
        //}

        if ($scope.user.AccountType && typeof $scope.user.AccountType === 'string') {

            const temp = $scope.user.AccountType.split(',');

            // Log sebelum konversi
            console.log("AccountType (string):", $scope.user.AccountType);
            console.log("Temp array (string):", temp);

            // Konversi ke array angka
            $scope.user.AccountType = temp.map(function (val) {
                return Number(val);
            });

            // Log sesudah konversi
            console.log("AccountType (array of number):", $scope.user.AccountType);
        }

    });

    $scope.selectCabang = function (item, model, label, event) {
        console.log('item:', item); // ✅ pastikan BranchName ada
        $scope.user.Sales = '';
        if (item.BranchCode) {
            $scope.user.Cabang = item.BranchCode;
            $scope.BranchSelected = item;
            // Otomatis ambil SalesPersonNID berdasarkan branch
            appFactory.getData(`service/client.svc/GetCIFSalesByBranch?BranchCode=${item.BranchCode}&BranchName=${item.BranchName}`).then(function (data){
                if (data.status == 200 && data.data.d) {
                    $scope.user.Sales = data.data.d.SalesPersonNID;
                }
            });
        }
    };


    //// when sales is selected
    //$scope.selectSales = function (item, model, label, event) {

    //    if (item.SalesPersonNID) {
    //        $scope.user.Sales = item.SalesPersonNID;
    //        $scope.SalesSelected = item;
    //    }
    //};


    //$scope.selectCabang = function (item, model, label, event) {

    //    $scope.user.Sales = '';

    //    if (item.BranchCode) {
    //        $scope.user.Cabang = item.BranchCode;
    //        $scope.BranchSelected = item;

    //        appFactory.getData(`service/client.svc/GetCIFSales?Code=${$scope.user.Cabang}`).then(function (data) {

    //            if (data.status == 200)
    //                $scope.ListSales = data.data.d;
    //        })
    //    }
    //};


        
    // check bank number duplication
    $scope.checkBankNumber = function () {
        if ($scope.user.BankNumber) {

            appFactory.getData(`service/client.svc/checkBankNumber?BK=${$scope.user.BankNumber}`).then(function (data) {

                if (data.status == 200) {

                    if (data.data.d != null) {
                        var obj = data.data.d;
                        if (obj.key && obj.key == 1) {
                            $scope.user.BankNumber = '';
                            Swal.fire('Failed', obj.value, "error");
                        }
                    }
                }
            });
        }
    }

    $scope.showAgreement = function (number) {

        let htmlName = 'template/Registeragereement' + number + '.html';
        var modalInstance = $uibModal
        .open({
            animation: true,
            templateUrl: htmlName,
            controller: 'RegisterAgreementCtrl',
            size: 'lg',
            backdrop: 'static',
            resolve: {

                agreementNumber: function () {

                    return number;
                }
            }
        });

        modalInstance.result.then(function (response, agree) {

            if (response == 'accept') {

                if (number == 1) {

                    $scope.agree1 = true;
                    $scope.disclaimerClose = true;
                }


                if ($scope.disclaimerClose == true);
            }
        }, function () { });
    };

    $scope.toggleAccountType = function (accountTypeId) {
        if (!$scope.user.AccountType) {
            $scope.user.AccountType = [];
        }

        const idx = $scope.user.AccountType.indexOf(accountTypeId);

        if (idx > -1) {
            // Hapus jika sudah ada
            $scope.user.AccountType.splice(idx, 1);
        } else {
            // Tambahkan jika belum ada
            $scope.user.AccountType.push(accountTypeId);
        }

        console.log("Selected Account Types:", $scope.user.AccountType);
    };

  
    //$scope.toggleFundSourceItem = function (fundsource) {

    //    let indexCIFLookupInteger = $scope.selectedFundSource.indexOf(fundsource.CIFLookupInteger);

    //    if (indexCIFLookupInteger > -1)
    //        $scope.selectedFundSource.splice(indexCIFLookupInteger, 1);
    //    else
    //        $scope.selectedFundSource.push(fundsource.CIFLookupInteger);

    //    if ($scope.selectedFundSource.indexOf(1) < 0)
    //        $scope.CIFInvestor.FundSourceText = '';

    //    $scope.changeSpouseMandatory();
    //}

    // jika url ke: register/{id sales} maka sales selected auto
    //if ($routeParams.id) {

    //    appFactory.getData(`service/client.svc/GetAliasSales?alias=${$routeParams.id}`).then(function (data) {

    //        if (data.status == 200) {
    //            // jika id sales di temukan maka:
    //            if (data.data.d.SalesPersonNID > 0) {

    //                $scope.user.Sales = data.data.d.SalesPersonNID;
    //                $scope.SalesSelected = data.data.d;
    //                $scope.disablesales = true;
    //            }
    //        }
    //    });
    //}

    // variables before submit post
    $scope.prepareData = function () {

        //if ($scope.user.Sales == "" || $scope.user.Sales == 0)
        //    $scope.user.Sales = 10509; //matiin dlu

        if ($scope.user.AccountType && Array.isArray($scope.user.AccountType)) {
            const joinedAccountTypes = $scope.user.AccountType.join(',');

            console.log("Gabungan AccountType untuk payload:", joinedAccountTypes);

            $scope.user.AccountType = joinedAccountTypes;
        }

    }

    $scope.submit = function () {

        var challenge = grecaptcha.getResponse();
        if (!challenge) {
            alert("Mohon ulangi centang captcha");
            return false;
        }
        else {
            $scope.user.challenge = challenge;
        }

        $scope.prepareData();

        // dynamic sweet alert post to app.js
        // 1: set the url of post or get request
        // 2: set the sweet alert translation, refers to apps.js $scope.SWALtranslate() :preconfirm = confirmation dialog before post or get request
        // 3: set the postdata to $http request = GET : {} / POST { yourdata : data }
        // 4: set the method to $http request = "GET" / "POST"
        // 5: set the sweet alert translation, refers to apps.js $scope.SWALtranslate() :preconfirm = confirmation dialog before post or get request
        // 6: if success or no error returns then...
        var urlsvc = 'service/client.svc/RegistrasiUser'; // 1
        var preconfirmtranslate = "submitregistrationconf"; // 2
        var postData = { User: $scope.user } // 3
        var method = "POST" // 4
        $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (issuccess) {

            if (issuccess) // 6
                $window.location.href = "#/login";
        });
    }

    $scope.validationinput = function () {

        if ($scope.user.FirstName != null
            && $scope.user.Email != null
            && $scope.user.Handphone != null
            && $scope.user.BankOwner != null
            && $scope.user.BankNumber != null
            && $scope.user.Password != null
            && $scope.ConfirmPassword != null
            && $scope.disclaimerRek != null
            && $scope.user.disclaimerBO != null
            && $scope.user.disclaimerAgreement != null
           ) {
            console.log('validation success');
        }
        else {
            var SWALtranslate = $scope.SWALtranslate('validationinput');

            Swal.fire({
                title: SWALtranslate.title,
                text: SWALtranslate.message,
                imageUrl: 'img/collection/wrong.png',
                imageAlt: 'Preparation',
                imageHeight: 250,
                animation: false
            });
        }
    }

}]);


app.controller('RegisterAgreementCtrl', ['$scope', '$uibModalInstance', 'agreementNumber', '$q', 'appFactory',
    function ($scope, $uibModalInstance, agreementNumber, $q, appFactory) {

        $scope.agreementNumber = agreementNumber;

        $scope.accept = function () {

            $uibModalInstance.close('accept', $scope.agreementNumber);
        };


        var allPromise = $q.all([


        ]);

        allPromise.then(function () {

        });

        $scope.cancel = function () {

            $uibModalInstance.dismiss('cancel', $scope.agreementNumber);
        };
    }]);